module.exports = __webpack_public_path__ + "21.bc417c58.png";